export default "__VITE_ASSET__B412LfdL__"